module.exports = __webpack_public_path__ + "img/logo.0e02435e.png";